module.exports = function (requireContext) {
  return requireContext.keys().map(requireContext)
}
